export enum DesignerAlertType {
	NEW_VERBATIM = 'NEW_VERBATIM',
	SCORECARD = 'SCORECARD'
}